import { render, staticRenderFns } from "./CardsAccess.vue?vue&type=template&id=4104187e&scoped=true&"
import script from "./CardsAccess.vue?vue&type=script&lang=js&"
export * from "./CardsAccess.vue?vue&type=script&lang=js&"
import style0 from "./CardsAccess.vue?vue&type=style&index=0&id=4104187e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4104187e",
  null
  
)

export default component.exports